import { convertEventTypes } from "./convertEventTypes";
import { convertTopics } from "./convertTopics";
import { feedFactoryAxios } from "../lib/axios";
import { Lang } from "../models";
import { FormValues } from "../models/FormValues";
import { LocationSelectionType } from "../models/LocationSelectionType";
import { convertEventLocationType } from "./convertEventLocationType";
import { internalToExternal } from "./internalToExternal";
import { getLocationTitle } from "./fetchLocations";

export const postNewEvent = (
  formValues: FormValues,
  locationSelectionType: LocationSelectionType | null
) => {
  // @ts-ignore
  const newEventInt: any = {
    entitytype: "EVENEMENT",
    id: null,
  };

  newEventInt.calendar = {
    singleDates: formValues.dates,
    hasComment: false,
    calendarType: "SINGLEDATES",
  };

  // @ts-ignore
  newEventInt.contactinfo = {
    urls: [
      {
        url: formValues.url,
        targetLanguage: Lang.NL,
        urlServiceType: "general",
      },
    ],
  };

  newEventInt.files = formValues.files;

  // @ts-ignore
  newEventInt.trcItemDetails = {
    [Lang.EN]: {
      title: formValues.title,
      shortdescription: formValues.shortDescription,
      longdescription: formValues.longDescription,
    },
  };

  if (locationSelectionType === LocationSelectionType.ManualLocation) {
    const address = formValues.locationAddress;
    address.country = "NL"; // Always assume NL for location in this form
    newEventInt.location = {
      address: address,
      label: formValues.locationLabel,
    };
  } else {
    if (formValues.locationItem) {
      // Not every venue has a title in its primary language, so fall back
      // rather than throwing on the way to the API.
      const locTitle = getLocationTitle(formValues.locationItem);
      newEventInt.location = {
        label: locTitle,
        locationItem: {
          text: locTitle,
          trcid: formValues.locationItem.trcid as string,
          id: formValues.locationItem.id as string,
        },
        address: formValues.locationItem.location?.address,
      };
    }
  }
  newEventInt.keywords = `startupevent;${convertEventTypes(
    formValues.typeOfEvent
  ).join(";")};${convertTopics(formValues.topics).join(
    ";"
  )};${convertEventLocationType(formValues.eventLocationType)}`;

  newEventInt.trcItemCategories = {
    types: [{ catid: "2.3.4" }],
  };

  newEventInt.translations = {
    primaryLanguage: Lang.EN,
    availableLanguages: [Lang.EN],
  };

  return feedFactoryAxios.post("/events", internalToExternal(newEventInt));
};
